export namespace EventsCalendar {
  export enum Pages {
    CALENDAR = 'calendar',
  }

  export enum EventTypeSlugs {
    WEBINAR = 'webinar',
    CONFERENCE = 'conference',
    LAW = 'law',
  }

  export interface EventCalendar {
    id: number;
    title: string;
    slug: string;
    slug_name: string;
    time: string;
    date: string;
    date_format: string;
    url: string | null;
    extra_url: string | null;
    is_expired: boolean
  }

  export interface MapEvent {
    id: number;
    name: string;
    start?: string;
    slug?: string;
    is_expired?: boolean,
    date?: string,
    date_format?: string,
  }

  export interface EventsCalendarItem {
    id: number;
    date: string;
    date_format: string;
    events: EventCalendar[];
  }

  export interface StatisticEvent {
    event_id: number;
    slug: string;
    user_agent: string;
  }

  export interface VuetifyCalendarDay {
    nativeEvent: {
      isTrusted: boolean;
    };
    date: string;
    time: string;
    year: number;
    month: number;
    day: number;
    weekday: number;
    hour: number;
    minute: number;
    hasDay: boolean;
    hasTime: boolean;
    past: boolean;
    present: boolean;
    future: boolean;
  }

  export interface EventsCalendarFilters {
    [key: string]: unknown;
    search: string;
    month: number,
    year: number,
  }
}
